module.exports = __webpack_public_path__ + "assets/img/baz.95a1dbd1.png";